import { oneOfType, element, node } from 'prop-types';

const Auxiliary = ({ children }) => children

Auxiliary.propTypes = {
  children: oneOfType([element, node]),
}

Auxiliary.defaultProps = {
  children: null,
}

export default Auxiliary

